/**
 * Runtime backend URL selector.
 *
 * A single React build is deployed to both GCP and Azure. Since
 * process.env vars are baked in at build time, we detect the host
 * at runtime and return the matching backend URL.
 *
 * GCP production:  Uses same-origin proxy (/api) served by server.js
 *                  to avoid CORS issues with custom domains.
 * Azure:           dmiqcoresvc.azurewebsites.net
 * Dev (localhost): Uses setupProxy.js (CRA dev server proxy)
 */

const AZURE_BACKEND = "https://dmiqcoresvc.azurewebsites.net";

const GCP_HOST_PATTERNS = ["appspot.com", "deepmediq.ai"];

function isGCP() {
  const hostname = window.location.hostname;
  return GCP_HOST_PATTERNS.some((pattern) => hostname.includes(pattern));
}

function isDev() {
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
}

// GCP + dev: use same-origin proxy (no CORS). Azure: direct backend.
export const API_URL = isDev() ? "" : isGCP() ? "" : AZURE_BACKEND;
